import { CommunitiesSkillAttributes } from 'types/graphql';
import { CommunitySkillAllocation } from 'pages/Settings/pages/LocationSettings/SkillsAllocation/store/locationSkills.store.types';

export const getCommunitiesSkillsAttributes = (
  appliedCommunitiesSkills: CommunitySkillAllocation[],
  selectedSkillIds: number[],
): CommunitiesSkillAttributes[] => {
  const appliedSkillIds = appliedCommunitiesSkills.map(({ skill }) => skill.displayId);
  return [
    ...selectedSkillIds
      .filter((skillId) => !appliedSkillIds.includes(skillId))
      .map((skillId) => ({ skillId })),
    ...appliedCommunitiesSkills
      .filter(({ skill }) => !selectedSkillIds.includes(skill.displayId))
      .map(({ displayId }) => ({ id: displayId, _destroy: true })),
  ];
};
